
import React from "react";
import {
  Box,
  Flex,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  HStack,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import User_list from "./User_list";
import School_list from "./School_list";
import CreateMember from "./CreateMember/Create_Member";
import Create_librarian from "../Librarian/Create_librarian";

const Main_Member = () => {
  return (
    <Box maxW="100%" p={4}>
      {/* Header */}
      <Flex
        justify="space-between"
        align="center"
        // borderBottom="1px solid"
        borderColor={useColorModeValue("gray.200", "gray.600")}
        // pb={3}
        // mb={4}
        pl={5}
      >
        <Heading size="md">Library Membership</Heading>

        <HStack spacing={3}>
          <Create_librarian />
          <CreateMember />
        </HStack>
      </Flex>

      {/* Breadcrumb */}
      <Breadcrumb fontSize="sm" mt={{base:"10px",md:"0"}} mb={3} pl={5}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/admin">
            Dashboard
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink>Library</BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink>Membership</BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      {/* Tabs */}
      <Box
        // p={4}
        borderRadius="md"
        bg={useColorModeValue("white", "gray.700")}
        shadow="sm"
      >
        <Tabs variant="soft-rounded" colorScheme="teal">
          {/* Tab List */}
          <Box mx={4} display="flex" justifyContent="flex-end">
            <TabList
              border="1px solid"
              borderColor={useColorModeValue("gray.300", "gray.600")}
              borderRadius="full"
              overflow="hidden"
            >
              <Tab
                _selected={{
                  bg: useColorModeValue("teal.100", "teal.600"),
                  color: "teal.800",
                  fontWeight: "bold",
                }}
                // borderRight="1px solid"
                borderColor={useColorModeValue("gray.300", "gray.600")}
              >
                School List
              </Tab>
              <Tab
                _selected={{
                  bg: useColorModeValue("teal.100", "teal.600"),
                  color: "teal.800",
                  fontWeight: "bold",
                }}
              >
                User List
              </Tab>
            </TabList>
          </Box>

          {/* Tab Panels */}
          <TabPanels>
            <TabPanel>
              <School_list />
            </TabPanel>
            <TabPanel>
              <User_list />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

export default Main_Member;
